module.exports = __webpack_public_path__ + "static/media/campus_10.ba71cb84.png";